// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"615a16f174352e49de51","655":"1827d5064a57aaf4a9d7"}[chunkId] + ".js";
};